export default {
  zh: {
    userPlod:'userName',
    passwordPlod:'password',
    errorTexl:'username or password error',
    LoginIn:'Login in',
    inviteNewHost:"Invite New Host",
    hostList:"Host List",
    leaderAdmins:"Leader & Admins",
    host:"Host",
    admin:"Admin",
    hosts:"Hosts",
    domTitle:"Manage host",
    joinApplication:'Host review',
    leader:"Leader",
  },
  en: {
    userPlod:'userName',
    passwordPlod:'password',
    errorTexl:'username or password error',
    LoginIn:'Login in',
    inviteNewHost:"Invite New Host",
    hostList:"Host List",
    leaderAdmins:"Leader & Admins",
    host:"Host",
    admin:"Admin",
    hosts:"Hosts",
    domTitle:"Manage host",
    joinApplication:'Host review',
    leader:"Leader",
  },
  ar: { // 阿拉伯
    userPlod:'اسم المستخدم',
    passwordPlod:'كلمة المرور',
    errorTexl:'خطا فى الاسم او الرقم السرى المستخدم',
    LoginIn:'الدخول في',
    joinApplication:"طلبات التقديم",
    hostList:"قائمة المضيفين",
    leaderAdmins:"المالك و الادمن",
    host:"مضيف",
    hosts:"المضيفين",
    admin:"المشرف",
    leader:"زعيم",
    domTitle:"إدارة المضييف",
    inviteNewHost:"دعوة مضيف جديد",
  },
  tr:{ //土耳其
    passwordPlod:'parola',
    userPlod:'kullanıcı adı',
    errorTexl:'Kullanıcı adı veya şifre hatası',
    LoginIn:'Giriş Yap',
    inviteNewHost:"Yeni Yayıncı Davet Et",
    hostList:"Yayıncılar Listesi",
    leaderAdmins:"Lider ve Yöneticiler",
    host:"Yayıncı",
    admin:"Admin",
    hosts:"Yayıncılar",
    leader:"Lider",
    domTitle:"Yayıncıyı Yönet",
    joinApplication:"Davet Bildirimi",
  },
  uz:{
  "userPlod": "foydalanuvchiNomi",
  "passwordPlod": "parol",
  "errorTexl": "foydalanuvchi nomi yoki parol xato",
  "LoginIn": "Kirish",
  "inviteNewHost": "Yangi mezbonni taklif qilish",
  "hostList": "Mezbonlar ro'yxati",
  "leaderAdmins": "Liderlar va Administratorlar",
  "host": "Mezbon",
  "admin": "Administrator",
  "hosts": "Mezbonlar",
  "domTitle": "Mezbonni boshqarish",
  "joinApplication": "Mezbonni ko'rib chiqish",
  "leader": "Lider"
},
    ru:{
  "userPlod": "имяПользователя",
  "passwordPlod": "пароль",
  "errorTexl": "ошибка имени пользователя или пароля",
  "LoginIn": "Войти",
  "inviteNewHost": "Пригласить нового хоста",
  "hostList": "Список хостов",
  "leaderAdmins": "Лидеры и администраторы",
  "host": "Хост",
  "admin": "Администратор",
  "hosts": "Хосты",
  "domTitle": "Управление хостом",
  "joinApplication": "Рассмотрение хоста",
  "leader": "Лидер"
},
    fa:{
  "userPlod": "نامکاربری",
  "passwordPlod": "رمزعبور",
  "errorTexl": "نام کاربری یا رمز عبور اشتباه است",
  "LoginIn": "ورود",
  "inviteNewHost": "دعوت از میزبان جدید",
  "hostList": "لیست میزبان‌ها",
  "leaderAdmins": "رهبران و مدیران",
  "host": "میزبان",
  "admin": "مدیر",
  "hosts": "میزبان‌ها",
  "domTitle": "مدیریت میزبان",
  "joinApplication": "بررسی میزبان",
  "leader": "رهبر"
},
    pt:{
  "userPlod": "nomeDeUsuario",
  "passwordPlod": "senha",
  "errorTexl": "erro no nome de usuário ou senha",
  "LoginIn": "Entrar",
  "inviteNewHost": "Convidar Novo Host",
  "hostList": "Lista de Hosts",
  "leaderAdmins": "Líderes e Administradores",
  "host": "Host",
  "admin": "Administrador",
  "hosts": "Hosts",
  "domTitle": "Gerenciar Host",
  "joinApplication": "Revisão do Host",
  "leader": "Líder"
},
    id:{
  "userPlod": "namaPengguna",
  "passwordPlod": "kataSandi",
  "errorTexl": "kesalahan nama pengguna atau kata sandi",
  "LoginIn": "Masuk",
  "inviteNewHost": "Undang Host Baru",
  "hostList": "Daftar Host",
  "leaderAdmins": "Pemimpin & Admin",
  "host": "Host",
  "admin": "Admin",
  "hosts": "Hosts",
  "domTitle": "Kelola Host",
  "joinApplication": "Tinjauan Host",
  "leader": "Pemimpin"
}





}


// WEBPACK FOOTER //
// src/pages/app/managementGo/lang.js